import { useEffect, useState } from 'react';
import AdminLayout from '@/components/layout/AdminLayout';
import { adminApi, Badge, Table } from './_shared';
import { Loader2 } from 'lucide-react';

const ACTION_TONE = { invite_sent: 'green', invite_failed: 'red', user_create: 'blue' };

export default function AdminInvitations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { adminApi.invitations().then(r => setItems(r.invitations || [])).finally(() => setLoading(false)); }, []);

  const cols = [
    { key: 'ts', header: 'When', render: r => <span className="text-[12px] text-slate-400 tabular-nums font-mono">{(r.ts || '').slice(0, 19).replace('T', ' ')}</span>, thStyle: { width: 170 } },
    { key: 'recipient', header: 'Recipient', render: r => <span className="text-slate-200 text-xs">{r.meta?.to || r.meta?.email || r.target_id || '—'}</span> },
    { key: 'action', header: 'Status', render: r => <Badge tone={ACTION_TONE[r.action] || 'slate'}>{r.action.replace('_', ' ')}</Badge> },
    { key: 'inviter', header: 'Inviter', render: r => <span className="text-slate-400 text-xs">{r.actor_email || '—'}</span> },
    { key: 'meta', header: 'Detail', render: r => (
      <span className="text-[11px] text-slate-500 font-mono">
        {r.meta?.email_id ? `id: ${r.meta.email_id}` : r.meta?.error ? `error: ${r.meta.error.slice(0, 60)}` : '—'}
      </span>
    )},
  ];

  return (
    <AdminLayout title="Invitations" subtitle="Admin · Email Activity">
      <p className="text-sm text-slate-400 mb-6 max-w-3xl">
        Every admin invitation sent via Resend (and every new-user creation) is recorded here.
        Use the Audit Log for the broader event timeline.
      </p>
      {loading ? (
        <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-slate-500"/></div>
      ) : (
        <Table columns={cols} rows={items} empty="No invitation activity yet. Add a new project admin to see emails appear here."
          getKey={r => r.audit_id || `${r.ts}-${r.action}`}/>
      )}
    </AdminLayout>
  );
}
